import React, { useState } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

function GroupedButtons({
	initialValue,
	minValue,
	maxValue,
	handleChange,
}: {
	initialValue: any;
	minValue: any;
	maxValue: any;
	handleChange: any;
}) {
	const [counter, setCounter] = useState(initialValue);

	const handleIncrement = () => {
		if (counter + 1 > maxValue) {
			return;
		}
		handleChange(counter + 1);
		setCounter(counter + 1);
	};

	const handleDecrement = () => {
		if (counter - 1 < minValue) {
			return;
		}
		setCounter(counter - 1);
		handleChange(counter - 1);
	};

	return (
		<ButtonGroup size="small" aria-label="small outlined button group">
			<Button onClick={handleDecrement}>-</Button>
			<Button disabled>{counter}</Button>
			<Button onClick={handleIncrement}>+</Button>
		</ButtonGroup>
	);
}

export default GroupedButtons;
